import { createAction, props, union } from '@ngrx/store';
import {
  PaymentRemittanceRules,
  PaymentRulesResponseV1,
} from '@arc/unified-payments-frontend/shared-payment';

export const GetPaymentAcceptanceRulesAction = createAction(
  '[Payment Rule] Get Payment Acceptance Rules Action',
);

export const GetPaymentRuleCompleteAction = createAction(
  '[Payment Rule] Get Payment Rule Complete Action',
  props<{
    payload: PaymentRulesResponseV1;
  }>(),
);

export const GetPaymentRuleErrorAction = createAction(
  '[Payment Rule] Get Payment Rule Error Action',
);

export const SetPaymentRuleToNullAction = createAction(
  '[Payment Rule] Set Payment Rule To Null Action',
);

export const UpdateRUMPaymentRulesTagsAction = createAction(
  '[Payment Rule] Update RUM Payment Rules Tags Action',
  props<{
    payload: PaymentRulesResponseV1;
  }>(),
);

export const GetPaymentRemittanceRulesAction = createAction(
  '[Payment Rule] Get Payment Remittance Rules Action',
  props<{
    payload: string;
  }>(),
);

export const GetPaymentRemittanceRulesCompleteAction = createAction(
  '[Payment Rule] Get Payment Remittance Rules Complete Action',
  props<{
    payload: PaymentRemittanceRules;
  }>(),
);

export const GetPaymentRemittanceRuleErrorAction = createAction(
  '[Payment Rule] Get Payment Remittance Rule Error Action',
);

const PaymentRulesActions = union({
  GetPaymentAcceptanceRulesAction,
  GetPaymentRuleCompleteAction,
  GetPaymentRuleErrorAction,
  SetPaymentRuleToNullAction,
  UpdateRUMPaymentRulesTagsAction,
  GetPaymentRemittanceRulesAction,
  GetPaymentRemittanceRulesCompleteAction,
  GetPaymentRemittanceRuleErrorAction,
});

export type PaymentRulesActionsUnion = typeof PaymentRulesActions;
